<div class="container">
  <app-attendee-jumbotron-activities
    *ngIf="jumbotron"
    class="col-span-12 py-5 -mx-3 xs:-mx-6 sm:-mx-9 lg:mx-0"
    [jumbotron]="jumbotron"
    [variant]="jumbotronVariant"
    [title]="jumbotron.title"
    [isHp]="true"
  >
    <app-attendee-home-filters-desktop
      *ngIf="!isTabletDevice"
      class="block mt-2 -mx-3 xs:-mx-6 sm:-mx-9 md:mt-0 lg:mx-0"
      (searched)="updateFilters($event)"
      [searchMode]="searchModeEnum.REGULAR"
      data-test="search-engine"
    ></app-attendee-home-filters-desktop>

    <app-attendee-home-filters-mobile
      *ngIf="isTabletDevice"
      class="block mt-2 -mx-3 xs:-mx-6 sm:-mx-9 md:mt-0 lg:mx-0"
      (searched)="updateFilters($event)"
      [searchMode]="searchModeEnum.REGULAR"
    ></app-attendee-home-filters-mobile>
  </app-attendee-jumbotron-activities>
</div>

<ng-container *ngIf="homeCms">
  <app-cms-section
    [section]="section"
    [isHp]="true"
    *ngFor="let section of homeCms?.sections; let isFirst = first"
    [ngClass]="{ 'block -mt-4 lg:-mt-3': isFirst }"
  ></app-cms-section>
</ng-container>
